import { useRef, useState } from "react";
import api, { API_BASE } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Play, Pause, Loader2, Volume2 } from "lucide-react";
import { toast } from "sonner";

/**
 * TTS Player — verilen metni OpenAI TTS ile sesli okutur.
 * Backend: GET/POST /api/ai/tts -> audio/mpeg
 */
export default function TTSPlayer({ text, voice = "nova", testid = "tts-player" }) {
  const audioRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [src, setSrc] = useState(null);
  const [playing, setPlaying] = useState(false);

  const load = async () => {
    if (src) return src;
    setLoading(true);
    try {
      const token = localStorage.getItem("ela_token");
      const resp = await fetch(`${API_BASE}/ai/tts`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ text, voice }),
      });
      if (!resp.ok) throw new Error("tts");
      const blob = await resp.blob();
      const url = URL.createObjectURL(blob);
      setSrc(url);
      return url;
    } catch (e) {
      toast.error("Ses oluşturulamadı");
      return null;
    } finally {
      setLoading(false);
    }
  };

  const toggle = async () => {
    const a = audioRef.current;
    if (playing) {
      a?.pause();
      setPlaying(false);
      return;
    }
    let url = src;
    if (!url) url = await load();
    if (!url) return;
    setTimeout(() => {
      if (audioRef.current) {
        audioRef.current.play();
        setPlaying(true);
      }
    }, 50);
  };

  return (
    <div className="inline-flex items-center gap-2" data-testid={testid}>
      <Button
        onClick={toggle}
        disabled={loading}
        variant="outline"
        size="sm"
        data-testid={`${testid}-toggle`}
        className="rounded-xl h-9 gap-1.5"
      >
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> :
          playing ? <Pause className="w-4 h-4" /> :
          <><Volume2 className="w-4 h-4" /><span className="hidden sm:inline">Dinle</span></>}
      </Button>
      <audio
        ref={audioRef}
        src={src || undefined}
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
        onEnded={() => setPlaying(false)}
        preload="none"
      />
    </div>
  );
}
